import * as yup from "yup";
export const IGNORE_ERROR = "IGNORE";


export const CONTRACT_SALE_CONTENT_TEMPLATE_EDIT_FORM_SCHEMA = yup.object().shape({
    name: yup.string().required('Molimo Vas da unesete naziv predloška'),
    items: yup
        .array()
        .required("Stavke su obavezne")
        .test(
            "at-least-one-active-item",
            "Morate dodati barem jednu stavku u predložak",
            items => Array.isArray(items) && items.some(item => !item?.deleted)
        ),
});
